import { withTracker } from '@/tracker';
import SEO from '@/components/seo';
import Hero from '@/components/about/hero';
import Why from '@/components/about/why';
import Team from '@/components/about/team';
import Investors from '@/components/about/investors';
import Location from '@/components/about/location';

function About () {
  return (
    <>
      <SEO
        title="About Bidali"
        description="Learn how we are redefining digital commerce and payments."
        keywords="bidali team about canada mission commerce economy decentralized distributed" />
      <Hero />
      <Why />
      <Team />
      <Investors />
      <Location />
    </>
  );
}

export default withTracker(About);
